import { defineComponent, ref } from "vue";
import type { IWithBubbletipProps } from "./types";
import Bubbletip from "../bubbletip";

const WithBubbletip = defineComponent<IWithBubbletipProps>({
  setup(props, { slots }) {
    const elRef = ref();
    return () => {
      return <span ref={elRef}>
        { slots.default ? slots.default() : '' }
        <Bubbletip {...props.tooltip} style={props.tooltipStyle || {}} triggerRef={elRef}/>
      </span>;
    }
  }
});

WithBubbletip.props = ['tooltip', 'tooltipStyle'];

export default WithBubbletip;
